module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('wallet-record-id')) ? _c('div', {
    staticClass: "field-wallet-record-id"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ID")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("WR" + _vm._s(_vm.item.id))])]) : (_vm.$is('wallet-record-walletable')) ? _c('div', {
    staticClass: "field-walletable"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Walletable")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.walletableType) + "(" + _vm._s(_vm.item.walletable_id) + ")")])]) : (_vm.$is('wallet-record-tax')) ? _c('div', {
    staticClass: "field-wallet-record-tax"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Tax")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.currency) + _vm._s(parseFloat((_vm.item.amount * -1) * _vm.item.tax).toFixed(2)))])]) : (_vm.$is('wallet-record-tax-rate')) ? _c('div', {
    staticClass: "field-wallet-record-tax-rate"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Tax Rate")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.tax * 100) + "%")])]) : (_vm.$is('wallet-record-amount')) ? _c('div', {
    staticClass: "field-wallet-record-amount"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Amount")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(" " + _vm._s(_vm.currency) + _vm._s(_vm.item.amount))])]) : (_vm.$is('wallet-record-created')) ? _c('div', {
    staticClass: "field-wallet-record-created"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('wallet-record-invoice')) ? _c('div', {
    staticClass: "field-wallet-invoice"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), (_vm.item.invoice.internal_id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_c('span', [_vm._v(" INV" + _vm._s(_vm.item.invoice.internal_id))])]) : _c('span', [_vm._v("Uninvoiced")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9429d8e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/WalletRecordFields.vue
// module id = 2745
// module chunks = 1